var LegalDocumentType;
(function (LegalDocumentType) {
    LegalDocumentType["Offer"] = "offer";
    LegalDocumentType["Privacy"] = "privacy";
    LegalDocumentType["PrivacyRule"] = "privacyRule";
    LegalDocumentType["Advertising"] = "advertising";
})(LegalDocumentType || (LegalDocumentType = {}));
export class LegalDocumentsService {
    api;
    legalDocumentsApi;
    offerLegalDocument;
    privacyLegalDocument;
    advertisingLegalDocument;
    privacyRuleLegalDocument;
    constructor(api) {
        this.api = api;
        this.legalDocumentsApi = api;
        this.offerLegalDocument = {
            link: "",
            isDefault: true
        };
        this.privacyLegalDocument = {
            link: "",
            isDefault: true
        };
        this.privacyRuleLegalDocument = {
            link: "",
            isDefault: true
        };
        this.advertisingLegalDocument = {
            link: "",
            isDefault: true
        };
    }
    async fetchLegalDocuments() {
        return this.legalDocumentsApi.getDocumentsList().then(responses => {
            for (let rsp of responses) {
                let ldType = this.getLegalDocumentType(rsp.type);
                if (ldType === undefined) {
                    continue;
                }
                switch (ldType) {
                    case LegalDocumentType.Offer:
                        this.offerLegalDocument.link = rsp.link;
                        this.offerLegalDocument.isDefault = false;
                        break;
                    case LegalDocumentType.Privacy:
                        this.privacyLegalDocument.link = rsp.link;
                        this.privacyLegalDocument.isDefault = false;
                        break;
                    case LegalDocumentType.PrivacyRule:
                        this.privacyRuleLegalDocument.link = rsp.link;
                        this.privacyRuleLegalDocument.isDefault = false;
                        break;
                    case LegalDocumentType.Advertising:
                        this.advertisingLegalDocument.link = rsp.link;
                        this.advertisingLegalDocument.isDefault = false;
                        break;
                }
            }
            return;
        }).catch(error => {
            console.error("Failed to fetch legal documents", error);
            return;
        });
    }
    getLegalDocumentType(value) {
        const values = Object.values(LegalDocumentType);
        if (values.includes(value)) {
            return value;
        }
        return undefined; // или выбросить ошибку
    }
}
